import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VideoLabelIcon(props: IconProps) {
    return <Icon {...props} iconKey={"video_label"}/>
}
